/** Keys used to persist list UI state across navigations. */
export const LIST_SEARCH_STORAGE_KEYS = [
  "searchedName",
  "TripsSearchName",
  "TripLogsSearchName",
  "RidersSearchName",
];

export const LIST_FILTER_STORAGE_KEYS = [
  "TripsFromDate",
  "TripsToDate",
  "TripLogsFromDate",
  "TripLogsToDate",
  "TripLogsRequestStatus",
  "TripLogsTripStatus",
];

export const LIST_PAGE_STORAGE_KEYS = [
  "Number",
  "TripsNumber",
  "TripLogsNumber",
  "RidersNumber",
];

/** Clear search / mid-filter state so returning to a list is a fresh page. */
export function clearListSearchPersistence() {
  LIST_SEARCH_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  LIST_FILTER_STORAGE_KEYS.forEach((key) => localStorage.removeItem(key));
  LIST_PAGE_STORAGE_KEYS.forEach((key) => localStorage.setItem(key, JSON.stringify(0)));
}
